import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { toast } from "sonner";
import { Palette } from "lucide-react";
import { resetCompanyMeta } from "@/components/CompanySwitcher";

const ACCENTS = ["#38bdf8", "#2563eb", "#16a34a", "#f59e0b", "#ea580c", "#dc2626", "#9333ea", "#0d9488", "#facc15", "#64748b"];

export function AccentDot({ customer, onChanged }) {
  const [busy, setBusy] = useState(false);
  const color = customer.accent_color;
  const save = async (v) => {
    setBusy(true);
    try {
      await api.patch(`/company/${customer.id}/accent`, { accent_color: v });
      resetCompanyMeta(); onChanged?.(customer.id, v);
      toast.success(v ? `Accent set for ${customer.company || customer.name}` : "Accent cleared");
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" disabled={busy} title={color ? `Accent ${color} · click to change` : "No accent chosen yet · click to set one"} className="inline-flex items-center justify-center h-5 w-5 rounded-full border-2 shrink-0 align-middle" style={color ? { backgroundColor: color, borderColor: color } : { borderColor: "#cbd5e1", borderStyle: "dashed" }} data-testid={`customer-accent-${customer.id}`}>
          {!color && <Palette className="h-3 w-3 text-slate-400" />}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-2" align="start" data-testid={`customer-accent-popover-${customer.id}`}>
        <div className="text-[11px] text-slate-500 mb-1.5">Accent color · colors their chips &amp; PDF covers</div>
        <div className="flex flex-wrap gap-1.5 max-w-[150px]">
          {ACCENTS.map((c) => <button type="button" key={c} onClick={() => save(c)} className={`h-6 w-6 rounded-full border-2 ${color === c ? "border-slate-900 scale-110" : "border-white"} shadow`} style={{ background: c }} data-testid={`customer-accent-pick-${c.slice(1)}`} />)}
          <label className="h-6 w-6 rounded-full border-2 border-dashed border-slate-300 flex items-center justify-center cursor-pointer overflow-hidden text-[10px] text-slate-500" title="Custom">+<input type="color" className="opacity-0 w-0 h-0" value={color || "#38bdf8"} onChange={(e) => save(e.target.value)} /></label>
        </div>
        {color && <button type="button" className="mt-2 text-[11px] text-slate-500 underline" onClick={() => save(null)} data-testid={`customer-accent-clear-${customer.id}`}>Clear</button>}
      </PopoverContent>
    </Popover>
  );
}
